import { OutlineElement } from '@phase2/outline-core';
import { CSSResultArray, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-quote.css.lit';

/**
 * Quote component
 * @element pc-quote
 */
@customElement('pc-quote')
export class PCQuote extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html` <div class="container">
      <slot></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-quote': PCQuote;
  }
}
